import { HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE } from 'src/common/constants';
import { PhoneLink } from 'src/components/Typography/PhoneLink';
import { getPhoneNumber } from 'src/components/Typography/PhoneLink/utils/getPhoneNumber';

export const DefaultSubHeading = () => (
    <>
        Please try again later or call us at <PhoneLink {...getPhoneNumber(HUMAN_LEGIBLE_DEFAULT_HELP_HOTLINE)} /> with
        any questions about Zillow Home Loans, including updates on your loan application.
    </>
);
